/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function PreferenceCenter_disablePrivacyPolicy(preferenceCenter) {
    const privacyPolicyContainer = preferenceCenter.querySelector('[data-component="PrivacyPolicyContainer"]');
    if (privacyPolicyContainer instanceof HTMLElement) {
        privacyPolicyContainer.style.display = "none";

        const checkbox = privacyPolicyContainer.querySelector('[type="checkbox"]');
        if (checkbox instanceof HTMLInputElement) {
            checkbox.checked = false;
            checkbox.required = false;
        }
    }
}
